import { clivApiRequest } from '@/utils/apiClient';
import { ApiRequestOptions } from '@/types/ApiRequestOptions';
import { Division } from '@/types/Division';
import { API_ENDPOINTS } from './endpoints.constant';
import { systemConfig } from '@/config/systemConfig';

export const divisionsApi = {
    /**
     * Fetch all divisions from the API
     * @returns Promise<Division[] | null> - Array of divisions or null if failed
     */
    async fetchDivisions(): Promise<Division[] | null> {
        try {
            const apiRequest: ApiRequestOptions = {
                url: `${systemConfig.apiUrl}/${API_ENDPOINTS.META.DIVISIONS}`,
            };

            const response = await clivApiRequest<Array<Division>>(apiRequest);

            if (response.ok) {
                return response.data;
            } else {
                console.error('Error fetching divisions:', response.error);
                return null;
            }
        } catch (error) {
            console.error('Error fetching divisions:', error);
            return null;
        }
    }
}; 